import React from 'react';

import { Container } from './styles';
import Link from 'next/link';

import { Button } from '../../../styles/components/Button';

export default function ErrorFinished({ label, name }) {
  return (
    <Container>
      <div>
        <h1>Oops!!</h1>

        <h2>Parece que essa vaga não está mais disponível!</h2>

        <img src="/static/time_expired.svg" alt="" />

        <Link href={`/${label}`}>
            <Button color="error">
            <span style={{ fontSize: 15, fontWeight: '400' }}>
                Veja outras vagas da {`${name}`}
            </span>
            </Button>
        </Link>
      </div>
    </Container>
  );
}
